import React from 'react';
import {View, Text, StyleSheet, Pressable} from 'react-native';
import moment from 'moment';
import Localized from 'src/constants/AppStrings';
import Styles from '../../../Styles';
import {DealStatus} from 'src/services/aws/DealRepository';
import {getDescriber} from '../../descriptor/DescriptorType';
import AVText from 'src/components/elements/AVText';
import UnReadlIcon from 'src/components/img/svg/UnReadIcon';
import {getNotificationDescriber} from 'src/components/elements/notificationDescriptor/DescriptorType';
import {GiftItem} from 'src/types/snack/GiftItem';
import {MessageTypeEnum} from 'src/constants/MessageTypeEnum';

type DealProps = {
  dealItem: GiftItem;
  selectedItemIndex: number;
  onPress: (dealItem: GiftItem, selectedItemIndex: number) => void;
  onDelete?: () => void;
};
type DealState = {
  isSwiping: boolean;
  expired: boolean;
  completed: boolean;
};

const margin = Styles.Spacing.m3 + Styles.Spacing.m2;

class DealItemCanteen extends React.Component<DealProps, DealState> {
  constructor(props: DealProps) {
    super(props);
    this.state = {
      expired: moment().isAfter(moment(props.dealItem.endDate)),
      completed: props.dealItem.dealStatus === DealStatus.redeemed,
      isSwiping: false,
    };
    this.onPress = this.onPress.bind(this);
  }

  onPress() {
    if (this.state.isSwiping) {
      return;
    }
    if (this.props.onPress) {
      this.props.onPress(this.props.dealItem, 0);
    }
  }

  renderExpirationText() {
    return getDescriber().dealRenderExpirationTxtTemplate();
  }

  render() {
    const describerProps = {
      styles,
      deal: this.props.dealItem,
      expired: this.state.expired,
    };
    return (
      <Pressable
        disabled={this.state.expired || this.state.completed}
        style={styles.btnCompleted}
        onPress={this.onPress}
        nativeID={'Btn-' + MessageTypeEnum.offers}
      >
        {getDescriber().dealRenderDealIcon()}
        <View style={styles.mainContent}>
          <View style={styles.titleHeaderView}>
            <Text
              style={getDescriber().dealStyleDescriptor().titleHeader}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm10}
              accessibilityLabel={Localized.Labels.offers}
              accessible
              testID="qa_NotificationType_txt"
              nativeID="qa_NotificationType_txt"
            >
              {Localized.Labels.offers}
            </Text>
            {this.renderExpirationText()}
          </View>
          <View style={styles.topSection}>
            {!this.props.dealItem.isRead && (
              <UnReadlIcon
                color={getNotificationDescriber().getUnreadMessageIconColor()}
              />
            )}
            <AVText
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm10}
              accessibilityLabel={getDescriber().dealRenderDealTopSection(
                describerProps,
              )}
              style={getDescriber().dealStyleDescriptor().dealName}
              numberOfLines={getDescriber().dealItemNumberDescriptor()}
              accessible
              testID="qa_MessageSubject_txt"
              nativeID="qa_MessageSubject_txt"
            >
              {getDescriber().dealRenderDealTopSection(describerProps)}
            </AVText>
          </View>

          {getDescriber().dealRenderDealNameDesc(describerProps)}
        </View>
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    borderRadius: Styles.Spacing.m2,
    marginTop: margin,
    paddingHorizontal: Styles.Spacing.m3,
    flexDirection: 'row',
    paddingVertical: Styles.Spacing.m3,
    flex: 1,
    marginHorizontal: margin,
  },
  topSection: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  mainContent: {
    flex: 1,
    marginLeft: Styles.Spacing.m3,
  },
  titleHeaderView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 2,
  },
  btnCompleted: {
    marginTop: Styles.Spacing.m3,
    marginHorizontal: Styles.Spacing.m3,
    paddingBottom: Styles.Spacing.m3,
    flexDirection: 'row',
    minHeight: Styles.Heights.touchTargetHeight2,
  },
});
export default DealItemCanteen;
